import React from 'react'
import styled from 'styled-components'
import { Navbar } from '../Navbar'

export default ({loc}: any) => (
  <NavbarContainer>
    <div className="wrapper">
      <Navbar invert loc={loc}/>
    </div>
  </NavbarContainer>
)

// Styles
const NavbarContainer = styled.div`
  display: flex;
  justify-content: center;
  .wrapper {
    width: 100%;
  }
`
